import Footer from "../components/footer";
import React, { useEffect, useState } from "react";
import axios from "axios";


import { FaPlay, FaTimes, FaCalendarAlt, FaYoutube } from "react-icons/fa";
import { API_URL } from "../App.js";

const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [tiposVideo, setTiposVideo] = useState([]);
  const [selectedTipo, setSelectedTipo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const videosPerPage = 9;

  function formatearFecha(fechaString) {
    const opciones = { year: "numeric", month: "long", day: "numeric" };
    const fecha = new Date(fechaString);
    return fecha.toLocaleDateString("es-ES", opciones);
  }

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        // Usar el endpoint del backend para obtener los videos de forma segura
        const response = await axios.get(API_URL + "youtube-videos/");

        if (response.data.message === 'success' && response.data.data) {
          const availableVideos = response.data.data.items.filter(
            (video) => video.id.videoId
          );
          setVideos(availableVideos);

          // Establecer los tipos de video
          if (response.data.data.tipos_video) {
            setTiposVideo(response.data.data.tipos_video);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchVideos();
  }, []);

  const indexOfLastVideo = currentPage * videosPerPage;
  const indexOfFirstVideo = indexOfLastVideo - videosPerPage;

  // Filtrar videos según el tipo seleccionado
  const filteredVideos = selectedTipo
    ? videos.filter((video) => video.tipo_video && video.tipo_video.tipo_video_id === selectedTipo)
    : videos;

  const currentVideos = filteredVideos.slice(indexOfFirstVideo, indexOfLastVideo);

  // Resetear a la primera página cuando cambia el filtro
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedTipo]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const openVideo = (video) => {
    setSelectedVideo(video);
    document.body.style.overflow = 'hidden';
  };

  const closeVideo = () => {
    setSelectedVideo(null);
    document.body.style.overflow = 'auto';
  };

  // Cerrar modal con tecla Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeVideo();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  return (
    <div className="flex flex-col flex-grow bg-gray-50">
      <br />

      {/* Barra de filtros por tipo de video */}
      {tiposVideo.length > 0 && (
        <div className="flex flex-wrap justify-center gap-2 mb-6 mx-4">
          <button
            onClick={() => setSelectedTipo(null)}
            className={`px-4 py-2 rounded-full font-sans font-medium transition-all duration-300 flex items-center gap-2 ${selectedTipo === null
                ? "bg-colorPrincipal text-white shadow-lg"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
          >
            <span>Todos</span>
            <span className={`text-xs px-2 py-0.5 rounded-full ${selectedTipo === null
                ? "bg-white/20"
                : "bg-gray-300"
              }`}>
              {videos.length}
            </span>
          </button>
          {tiposVideo.map((tipo) => {
            const count = videos.filter(v => v.tipo_video && v.tipo_video.tipo_video_id === tipo.id).length;
            return (
              <button
                key={tipo.id}
                onClick={() => setSelectedTipo(tipo.id)}
                className={`px-4 py-2 rounded-full font-sans font-medium transition-all duration-300 flex items-center gap-2 ${selectedTipo === tipo.id
                    ? "bg-colorPrincipal text-white shadow-lg"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
              >
                <span>{tipo.nombre}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${selectedTipo === tipo.id
                    ? "bg-white/20"
                    : "bg-gray-300"
                  }`}>
                  {count}
                </span>
              </button>
            );
          })}
        </div>
      )}

      {/* Grid de Videos */}
      <div className="container mx-auto px-4 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {currentVideos.map((video) => (
            <div
              key={video.id.videoId}
              className="group cursor-pointer"
              onClick={() => openVideo(video)}
            >
              <div className="bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2">
                {/* Miniatura */}
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={video.snippet.thumbnails.high?.url || video.snippet.thumbnails.medium?.url}
                    alt={video.snippet.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  {/* Overlay con botón de play */}
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <div className="w-16 h-16 rounded-full bg-colorPrincipal/90 flex items-center justify-center transform scale-75 group-hover:scale-100 transition-transform duration-300">
                      <FaPlay className="text-white text-xl ml-1" />
                    </div>
                  </div>
                  {/* Badge de duración simulado */}
                  <div className="absolute bottom-2 right-2 bg-black/80 text-white text-xs px-2 py-1 rounded font-medium">
                    <FaYoutube className="inline mr-1" />
                    YouTube
                  </div>
                </div>

                {/* Contenido */}
                <div className="p-4">
                  <h3 className="font-bold font-sans text-gray-800 mb-2 group-hover:text-colorPrincipal transition-colors duration-300 text-sm leading-snug h-[60px] overflow-hidden">
                    {video.snippet.title}
                  </h3>
                  <div className="flex items-center text-gray-500 text-sm">
                    <FaCalendarAlt className="mr-2" />
                    <span className="font-sans">{formatearFecha(video.snippet.publishedAt)}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Paginación mejorada */}
        <div className="flex justify-center mt-10">
          <div className="flex items-center gap-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded-lg font-sans font-medium transition-all duration-300 ${currentPage === 1
                  ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                  : 'bg-colorPrincipal text-white hover:bg-colorSecudario shadow-md hover:shadow-lg'
                }`}
            >
              Anterior
            </button>

            <div className="flex items-center gap-1">
              {Array.from({ length: Math.ceil(filteredVideos.length / videosPerPage) }, (_, i) => i + 1)
                .filter(page => {
                  return page === 1 ||
                    page === Math.ceil(filteredVideos.length / videosPerPage) ||
                    Math.abs(page - currentPage) <= 1;
                })
                .map((page, index, arr) => (
                  <React.Fragment key={page}>
                    {index > 0 && arr[index - 1] !== page - 1 && (
                      <span className="px-2 text-gray-400">...</span>
                    )}
                    <button
                      onClick={() => handlePageChange(page)}
                      className={`w-10 h-10 rounded-lg font-sans font-medium transition-all duration-300 ${currentPage === page
                          ? 'bg-colorPrincipal text-white shadow-md'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                    >
                      {page}
                    </button>
                  </React.Fragment>
                ))}
            </div>

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === Math.ceil(filteredVideos.length / videosPerPage)}
              className={`px-4 py-2 rounded-lg font-sans font-medium transition-all duration-300 ${currentPage === Math.ceil(filteredVideos.length / videosPerPage)
                  ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                  : 'bg-colorPrincipal text-white hover:bg-colorSecudario shadow-md hover:shadow-lg'
                }`}
            >
              Siguiente
            </button>
          </div>
        </div>

        {/* Indicador de resultados */}
        <div className="text-center text-gray-600 text-sm font-sans mt-4">
          Mostrando {indexOfFirstVideo + 1} - {Math.min(indexOfLastVideo, filteredVideos.length)} de {filteredVideos.length} videos
        </div>
      </div>

      {/* Modal de Video Expandido */}
      {selectedVideo && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4 animate-fadeIn"
          onClick={closeVideo}
        >
          {/* Backdrop oscuro */}
          <div className="absolute inset-0 bg-black/90 backdrop-blur-sm"></div>

          {/* Contenido del Modal - centrado */}
          <div
            className="relative w-full max-w-3xl bg-white rounded-2xl shadow-2xl overflow-hidden animate-scaleIn z-10"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Botón cerrar */}
            <button
              onClick={closeVideo}
              className="absolute top-2 right-2 z-10 w-8 h-8 rounded-full bg-black/50 hover:bg-black/70 text-white flex items-center justify-center transition-all duration-300 hover:rotate-90"
            >
              <FaTimes className="text-lg" />
            </button>

            {/* Video Player */}
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${selectedVideo.id.videoId}?autoplay=1`}
                allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                title={selectedVideo.snippet.title}
              ></iframe>
            </div>

            {/* Info del video */}
            <div className="p-3 bg-gradient-to-r from-gray-50 to-white">
              <h2 className="text-base font-bold font-sans text-gray-800 mb-1">
                {selectedVideo.snippet.title}
              </h2>
              <div className="flex flex-wrap items-center gap-3 text-gray-500 text-xs">
                <div className="flex items-center">
                  <FaCalendarAlt className="mr-1" />
                  <span className="font-sans">{formatearFecha(selectedVideo.snippet.publishedAt)}</span>
                </div>
                <a
                  href={`https://www.youtube.com/watch?v=${selectedVideo.id.videoId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-red-600 hover:text-red-700 transition-colors"
                >
                  <FaYoutube className="mr-1" />
                  Ver en YouTube
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Estilos de animación */}
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { 
            opacity: 0; 
            transform: scale(0.9);
          }
          to { 
            opacity: 1; 
            transform: scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-scaleIn {
          animation: scaleIn 0.3s ease-out;
        }
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default Videos;
